import React from 'react'
import { ClipLoader } from 'react-spinners'

export const ClipLoaderSpinner = (props: any) => {
  const { size, color, loading } = props
  //"#00B7B9"
  return <ClipLoader size={size} color={color} loading={loading}></ClipLoader>
}
